import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getWalletBalance, getWalletTransactions, requestCashout } from '../../services/walletService';
import toast from 'react-hot-toast';
import BackButtonBottom from '../../components/common/BackButtonBottom';

export default function RiderWallet() {
  const { currentUser } = useAuth();
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;
    Promise.all([
      getWalletBalance(currentUser.uid),
      getWalletTransactions(currentUser.uid),
    ]).then(([bal, txs]) => { setBalance(bal); setTransactions(txs); })
      .catch(console.error).finally(() => setLoading(false));
  }, [currentUser]);

  if (loading) return <div className="flex justify-center p-20"><div className="spinner spinner-lg" /></div>;

  return (
    <div className="max-w-[600px] mx-auto px-6 py-8">
      <Link to="/rider" className="text-brand-primary font-semibold text-[0.9rem] mb-6 block">← Dashboard</Link>
      <h1 className="font-serif text-[1.8rem] mb-8">My Wallet</h1>
      <div className="card text-center mb-6" style={{ background: 'linear-gradient(135deg, #2dd4a8, #6ee7b7)', color: '#0a1628' }}>
        <div className="text-[0.9rem] font-medium opacity-70 mb-1">Total Balance</div>
        <div className="text-[2.5rem] font-extrabold">${(balance?.totalBalance || 0).toFixed(2)}</div>
        <div className="flex justify-center gap-6 mt-4 text-[0.85rem]">
          <span>Refunds: ${(balance?.refundCredits || 0).toFixed(2)}</span>
          <span>Gift Cards: ${(balance?.giftCardCredits || 0).toFixed(2)}</span>
        </div>
      </div>
      <h3 className="font-bold mb-4">Recent Transactions</h3>
      {transactions.length === 0 ? (
        <p className="text-muted text-center p-8">No transactions yet.</p>
      ) : transactions.map((tx) => (
        <div key={tx.id} className="flex justify-between py-3.5" style={{ borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
          <div>
            <div className="font-semibold text-[0.92rem]">{tx.description}</div>
            <div className="text-muted text-[0.82rem]">{tx.createdAt?.toDate?.()?.toLocaleDateString() || '—'}</div>
          </div>
          <div className="font-bold" style={{ color: tx.amount >= 0 ? '#2dd4a8' : '#ff6b6b' }}>
            {tx.amount >= 0 ? '+' : ''}${Math.abs(tx.amount).toFixed(2)}
          </div>
        </div>
      ))}
      <BackButtonBottom to="/rider" label="Dashboard" />
    </div>
  );
}